const messages = {
    availPoints: "Налични точки",
    awaitingPoints: "Очакващи точки",
  board: {
    title: "Табло за управление",
    title2: "Анимация на представянето {year}",
    headline1: "Вашите промоции и точки с един поглед",
    headline2: "Спечелете точки за покупките си на гуми.",
    pointsBalanceToDate: "БАЛАНС НА ТОЧКИТЕ КЪМ ДАТА",
    availPoints: "Налични точки",
    awaitingPoints: "Очакващи точки",
    yourRealisation: "ВАШИТЕ ПОСТИЖЕНИЯ",
    yourEngagement: "Вашият годишен ангажимент: <b>{tyres} гуми</b>",
    yourPoints: "ВАШИТЕ ТОЧКИ",
    yourRetailPurchase: "ВАШИТЕ ПОКУПКИ НА ДРЕБНО",
    yourRetailPurchaseCCS: "ВАШИТЕ ПРОДАЖБИ НА ДРЕБНО",
    pointsByPurchase: "точки, генерирани от покупките ви",
    pointsByBoosters: "точки, генерирани от бустерите",
    pointsByBSPurchase: "Точки, генерирани от покупките ви на Bridgestone",
    pointsByBSPurchaseCCS:
      "Точки, генерирани от продажбите ви на гуми Bridgestone",
    remaining: "Оставащи гуми",
    yourGoal: "Напредък към целта",
    unit: "гуми",
    buttons: {
      learnMore: "Научете повече за вашите точки",
      learnMoreAboutMechanism: "Научете повече за механизма",
    },
    charts: {
      byBrand: "По марка",
      bySize: "По размер<br/>на джантата",
    },
    exploreResults: "Открийте резултатите си",
    tyreLimitInfo:
      "Изисква се минимален обем на разпродажба от 50 гуми Bridgestone и/или Firestone за всеки период на Booster кампания",
  },
  charts: {
    byBrand: "По марка",
    bySize: "по размер на джантата",
  },

  dashboard: {
    dashboardTitle: "Вашите предимства",
    dashboardBox: {
      title: "Баланс на точките",
      description: "Текущ общ маркетингов баланс точки",
      availPoints: "Налични точки",
      awaitingPoints: "Очакващи точки",
      lastUpdate: "Последна актуализация",
      button: "Научете повече",
      points: "точки",
    },
  },
  soldTyres: "ПРОДАДЕНИ ГУМИ",
  receivedPoints: "СПЕЧЕЛЕНИ ТОЧКИ",
  boosterCCS: {
    personalInfo: "Лична информация",
    csNumberTitle: "Моля, посочете номера на участващия акаунт/акаунти",
    tyresTitle: "Моля, посочете броя на продадените гуми",
    minTyresInfo:
      "Необходими са минимум {tyres} гуми Bridgestone/Firestone. Компенсацията важи само за гуми Bridgestone.",
    tyresAmount: "Брой гуми",
    filesTitle: "Моля, качете доказателство за продажбите",
    filesDescription:
      "Моля, имайте предвид: ще се приемат само продажби с посочен размер на джантата на гумата.",
    addAnotherFile: "Добавете друг документ",
    file: "Качете документ",
    formatInfo:
      "Приемани формати: xlsx, jpeg и pdf. Максимален размер на файла: 8 MB",
    confrimationMessage:
      "<b>Благодарим за участието!</b> <br/>Вашата заявка е получена и е изпратена към екипите на Bridgestone за проверка.<br/>Ще получите имейл с резултата от участието ви в Booster CCS.<br/>До скоро в Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Споделяне на точки",
    forShare: "Точки, които ще споделите",
    title: "Заглавие",
  },
  notFoundFile: "Няма избран файл",
  chooseFile: "Изберете файл",
};
export default {
  messages,
};
